import React from "react";
import { CheckIcon, InfoIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { volumes } from "../../data/content";
export function VolumesSection() {
  return <section className="bg-cream px-5 py-16 sm:py-24" aria-label="What you'll find inside" data-id="element-356" data-mp="2munas7hskjcb">
      <div className="mx-auto max-w-5xl" data-id="element-357" data-mp="2rsf332mcm7h1">
        <SectionHeading eyebrow="What you'll find inside" title="6 Premium Volumes. One Complete Educational System." data-id="element-358" data-mp="2e2l9y83t911i" />

        <div className="mt-12 space-y-8" data-id="element-359" data-mp="2itjvbm3nopbm">
          {volumes.map(v => <article key={v.number} className="overflow-hidden rounded-3xl bg-white shadow-[0_12px_40px_-20px_rgba(11,31,63,0.35)]" data-id="element-360" data-mp="244f97ttqq0y8">
              <div className="px-5 py-6 sm:px-8 sm:py-8 text-white" style={{
            backgroundColor: v.color
          }} data-id="element-361" data-mp="294jv5zdf3nvu">
                <p className="text-sm font-extrabold uppercase tracking-[0.2em] text-white/80" data-id="element-362" data-mp="1v50mn5gp2aj0">Volume {v.number}</p>
                <h3 className="mt-2 font-serif text-[26px] sm:text-4xl font-bold leading-tight" data-id="element-363" data-mp="1z4svzkdwwkpf">{v.title}</h3>
                <p className="mt-2 text-base sm:text-lg text-white/90" data-id="element-364" data-mp="1fhfh6v8xllcb">{v.subtitle}</p>
              </div>
              <div className="px-5 py-6 sm:px-8 sm:py-8" data-id="element-365" data-mp="1am9sxps23ul2">
                <p className="text-base sm:text-[17px] leading-relaxed text-ink/80" data-id="element-366" data-mp="1pgepudtp5gzb">{v.intro}</p>
                <p className="mt-6 text-sm font-extrabold uppercase tracking-wider" style={{
              color: v.color
            }} data-id="element-367" data-mp="1kjek640reg8q">
                  {v.listLabel}
                </p>
                <ul className="mt-3 grid gap-x-8 gap-y-2.5 sm:grid-cols-2" data-id="element-368" data-mp="rtpdba1dblz7">
                  {v.items.map(item => <li key={item} className="flex gap-2.5 text-[15px] sm:text-base text-ink" data-id="element-369" data-mp="16ity8yzjs4b0">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0" style={{
                  color: v.color
                }} aria-hidden="true" data-id="element-370" data-mp="11rc16m0nanvb" />
                      <span data-id="element-371" data-mp="e19aa98gvnya">{item}</span>
                    </li>)}
                </ul>
                <p className="mt-6 flex gap-2.5 rounded-xl bg-cream px-4 py-3 text-sm sm:text-[15px] leading-relaxed text-ink/75" data-id="element-372" data-mp="92eqp52odvd4">
                  <InfoIcon className="mt-0.5 h-4 w-4 shrink-0 text-ink/50" aria-hidden="true" data-id="element-373" data-mp="yp9384z7080u" />
                  <span data-id="element-374" data-mp="12quanasyju3n">{v.note}</span>
                </p>
              </div>
            </article>)}
        </div>

        <div className="mt-12" data-id="element-375" data-mp="1ciqk1i0hv6n6">
          <CtaButton label="I want all 6 volumes today" data-id="element-376" data-mp="1choy2ihxwzqo" />
        </div>
      </div>
    </section>;
}